// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const FlowChartGroup: MarkdocTagRegistration = {
  tag: 'flow-chart-group',
  component: 'FlowChartGroup',
};
